import { defineNuxtPlugin } from '@nuxtjs/composition-api';

import { useSentry } from '@/plugins/sentry';
import { useGlobalStore } from '@/store/global';

export default defineNuxtPlugin(async (nuxtApp) => {
  const sentry = useSentry();
  try {
    const globalStore = useGlobalStore(nuxtApp.$pinia);
    await globalStore.globalInit();
  } catch (error) {
    console.log('🚀 ~ file: globalStore.client.ts ~ defineNuxtPlugin ~ error', process.client, error);
    sentry.captureException(error);
  }
});
